export enum WaterHeatExchangerConfiguration {
  COUNTER_CURRENT = 'Counter-current',
  CO_CURRENT = 'Co-current',
}
